<template>
  <div class="delModel" v-if="isShow">
    <div class="model-dissolve">
      <p class="head">{{ dialogHeadTxt }}</p>
      <p class="title h60" v-html="delMessage"></p>
      <div class="dissolve-box">
        <div class="btnclose" @click="handleClose">{{ dialogCloseBtnTitle }}</div>
        <div class="btn0k" @click="handleSave">{{ dialogOkBtnTitle }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dialogHeadTxt: {
      type: String,
      default: '提示',
    },
    delMessage: {
      type: String,
      default: '确认删除吗?',
    },
    dialogOkBtnTitle: {
      type: String,
      default: '确定'
    },
    dialogCloseBtnTitle: {
      type: String,
      default: '取消'
    }
  },
  data() {
    return {
      isShow: false,
      item: {}
    }
  },
  methods: {
    init(acc) {
      console.log(acc)
      this.item = acc
      this.isShow = !this.isShow
    },
    handleClose() {
      this.isShow = false
      this.$emit('handleClose')
    },
    handleSave() {
      this.$emit('handleDelSave', this.item)
    }
  }
}
</script>

<style lang="less" scoped>
.delModel {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 26px;

  .model-dissolve {
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -160px;
    margin-top: -98px;
    background: #fff;
    border-radius: 10px;
    width: 320px;
    min-height: 195px;
    padding: 15px 17px 16px;
    box-sizing: border-box;

    .head {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 600;
      font-size: 17px;
      color: #000000;
      line-height: 20px;
      margin-bottom: 20px;
      text-align: center;
    }

    .title {
      color: rgb(0, 0, 0);
      font-family: PingFang SC;
      font-size: 17px;
      font-weight: 400;
      line-height: 24px;
      text-align: center;
    }

    .h60 {
      min-height: 60px;
    }

    .dissolve-box {
      margin-top: 16px;
      display: flex;
      align-items: center;

      .btnclose {
        flex: 1;
        height: 42px;
        background: rgba(0, 0, 0, 0.08);
        border-radius: 20px;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        font-size: 16px;
        color: #7a8494;
        line-height: 42px;
        text-align: center;
      }

      .btn0k {
        margin-left: 27px;
        flex: 1;
        height: 42px;
        background: #EB1700;
        box-shadow: 0px 2px 4px 0px rgba(255, 91, 12, 0.25);
        border-radius: 22px;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        font-size: 16px;
        color: #ffffff;
        line-height: 42px;
        text-align: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/grade/components/dialogDel.vue